(function () {
    'use strict';

    function deleteWorkflowModalController($scope, $uibModalInstance, notifyService, workflowDataService,
        workflowId, workflowTypeIdentifier) {
        $scope.deleteMessage = "Are you sure you want to delete this " +
            workflowTypeIdentifier.toLowerCase() + "?";

        $scope.ok = function () {
            workflowDataService.deleteWorkflow(workflowId).then(
                function() {
                    notifyService.notify('This workflow has been deleted');
                });
            $uibModalInstance.close(true);
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        }
    }

    deleteWorkflowModalController.$inject = ['$scope', '$uibModalInstance', 'notifyService',
        'workflowDataService', 'workflowId', 'workflowTypeIdentifier'];

    angular.module('ecap.workflow').controller('deleteWorkflowModalController', deleteWorkflowModalController);
})();
